import { Routes, Route, Navigate } from 'react-router';
import { AuthLayout, DashboardLayout } from '@layouts';
import { PrivateRoute } from './PrivateRoute';
import { SecureLinkRoute } from './SecureLinkRoute';

import {
  LoginPage, HomePage, AssetsPage, AssetDetailsPage,
  AnomalySuitePage, InspectionSuitePage, ComponentRegisterPage,
  ReportBrowserPage, SettingsPage, ContactPage, RequestPage,
  HistoryPage
} from '@/pages';

import FeatureGate from '@/shared/feature-availability/FeatureGate';
import { HierarchicalGridBuilder } from '@/features/anomaly-taxonomy'


export function AppRouter() {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path="/home" element={<FeatureGate feature="home"><HomePage /></FeatureGate>} />
        <Route path="/assets" element={<FeatureGate feature="assets"><AssetsPage /></FeatureGate>} />
        <Route path="/assets/:assetId" element={<FeatureGate feature="assets"><AssetDetailsPage /></FeatureGate>} />
        <Route path="/iod" element={<FeatureGate feature="iod"><ComponentRegisterPage /></FeatureGate>} />
        <Route path="/anomaly-suite" element={<FeatureGate feature="anomalies"><AnomalySuitePage /></FeatureGate>} />
        <Route path="/report-browser" element={<FeatureGate feature="reports"><ReportBrowserPage /></FeatureGate>} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/request" element={<RequestPage />} />

        <Route path="/inspection-suite" element={<FeatureGate feature="inspection"><InspectionSuitePage /></FeatureGate>} />
        <Route path="/history" element={<FeatureGate feature="history"><HistoryPage /></FeatureGate>} />
        <Route path="/test/anomaly-taxonomy" element={<FeatureGate feature="taxonomy"><HierarchicalGridBuilder /></FeatureGate>} />

      </Route>

      <Route
        element={
          <SecureLinkRoute>
            <DashboardLayout />
          </SecureLinkRoute>
        }
      >
        {/* <Route path="/shared/viewer/:shareId" element={<SharedViewerPage />} /> */}
      </Route>

      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
}
